import React, { useState } from "react";
import { Box, IconButton, Collapse, Typography } from "@mui/material";
import { getIcon, Divider } from "@dishopsaas/design-system";
import { getColors } from "../../../src/utils/style";

interface CardBoxProps {
  children: React.ReactNode;
  sx?: any;
}

interface CollapsibleCardBoxProps {
  title: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  sx?: any;
}

export const CardBox: React.FC<CardBoxProps> = ({ children, sx = {} }) => {
  const { border, bgwhite, text } = getColors();
  return (
    <Box
      sx={{
        borderRadius: 1,
        border: border,
        bgcolor: bgwhite,
        fontFamily: "PP Right Grotesk Casual Variable",
        color: text,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export const CollapsibleCardBox: React.FC<CollapsibleCardBoxProps> = ({
  title,
  children,
  defaultOpen = true,
  sx = {},
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <CardBox sx={sx}>
      <Box
        sx={{
          mb: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          pl: 3,
          pr: 1,
          pt: 3,
          pb: 1,
        }}
        onClick={() => setOpen(!open)}
      >
        <Typography variant="h5" >{title}</Typography>
        <IconButton size="small">
          <Box
            sx={{
              display: "flex",
              transform: open ? "rotate(-90deg)" : "rotate(0deg)",
              transition: "0.2s",
            }}
          >
            {getIcon("ChevronDown", { width: "24px", height: "24px" })}
          </Box>
        </IconButton>
      </Box>
      {open && <Divider sx={{ borderBottomColor: getColors().border, borderWidth: 0.5 }} />}
      <Collapse in={open}>{children}</Collapse>
    </CardBox>
  );
};
